import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EventIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.883 1.007L16 1a1 1 0 01.993.883L17 2v1h2a3 3 0 013 3v2.966l.005.084c0 .029 0 .056-.003.084L22 20a3 3 0 01-3 3H5a3 3 0 01-3-3V6a3 3 0 013-3h2V2a1 1 0 01.883-.993L8 1a1 1 0 01.993.883L9 2v1h6V2a1 1 0 01.883-.993L16 1zM20 10.05H4V20a1 1 0 001 1h14a1 1 0 001-1v-9.95zm-7.103 2.507l.649 1.315 1.451.211a1 1 0 01.554 1.706l-1.05 1.024.248 1.445a1 1 0 01-1.451 1.054L12 18.63l-1.298.682a1 1 0 01-1.451-1.054l.248-1.445-1.05-1.024a1 1 0 01.554-1.706l1.451-.21.65-1.316a1 1 0 011.793 0zM7 5H5a1 1 0 00-1 1v2.05h16V6a1 1 0 00-1-1h-2v1a1 1 0 01-.883.993L16 7a1 1 0 01-.993-.883L15 6V5H9v1a1 1 0 01-.883.993L8 7a1 1 0 01-.993-.883L7 6V5z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
EventIcon.isCarinaIcon = true;
export default EventIcon;
